"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyForPointsButton = void 0;
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _react = require("react");
var _contexts = require("../contexts");
var _useTranslations = require("../hooks/useTranslations");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable no-negated-condition -- needed */

const BuyForPointsButton = exports.BuyForPointsButton = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    loyaltyPrice,
    loyaltyPoints
  } = (0, _contexts.useLoyaltyDialog)();
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const plusLoyaltyPrice = ` + ${(0, _culture.useFormatCurrency)(loyaltyPrice ?? 0)}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Button, {
    ref: ref,
    fullWidth: true,
    variant: "contained",
    color: "primary",
    ...props,
    children: [formatMessage('pointsCount', {
      0: loyaltyPoints ?? 0
    }), loyaltyPrice !== 0 ? plusLoyaltyPrice : null]
  });
});
